export const ENCOUNTER_ROUTE = '/encounter';
export const ENCOUNTER_LIVE_ROUTE_PATTERN = ENCOUNTER_ROUTE;
export const GROUP_ENCOUNTER_ROUTE = '/group-encounter';
export const TELEPHONIC_ENCOUNTER_ROUTE = '/telephonic-encounter';
// Generalized live phone-encounter view (single-leg + three-way) that the
// planner navigates to after starting a phone call.
export const PHONE_SESSION_ROUTE = '/phone-session';
// Live video-bot encounter view (Recall.ai / RingCentral). The planner
// navigates here after summoning a join-now video bot; it reuses the live
// interpreter encounter view and controls the agent over RPC.
export const VIDEO_SESSION_ROUTE = '/video-session';

export const buildLiveEncounterRouteState = (
  state: Record<string, unknown> | null = {},
  _sessionId?: string | null,
): Record<string, unknown> => {
  const baseState = state || {};
  return Object.fromEntries(
    Object.entries(baseState).filter(([key]) => key !== 'encounterSessionId'),
  );
};

export const buildLiveEncounterPath = () => ENCOUNTER_ROUTE;

export const buildLiveEncounterRoute = (
  state: Record<string, unknown> | null = {},
  sessionId?: string | null,
) => {
  const nextState = buildLiveEncounterRouteState(state, sessionId);
  return {
    path: buildLiveEncounterPath(),
    state: nextState,
  };
};
